export const POSITION = 'Position';
export const DEPARTMENT = 'Department';
